"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Column = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Column = function Column(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      gutterUnit = _ref.gutterUnit,
      stack = _ref.stack,
      split = _ref.split,
      size = _ref.size,
      flex = _ref.flex,
      align = _ref.align; // When stack is enabled, we don't return traces of the columns div tags

  if (stack) return (0, _core.jsx)(_react.Fragment, null, children);
  var styles =
  /*#__PURE__*/
  (0, _core.css)("box-sizing:border-box;min-width:0;", gutterUnit && 'margin-left: ' + gutterUnit * 0.5 + 'em;', " ", gutterUnit && 'margin-right: ' + gutterUnit * 0.5 + 'em;', " ", size && !split && 'width: ' + size + 'em;', " ", flex && !split && 'flex: 1;', " ", align && 'text-align: ' + align.toLowerCase() + ';', "label:styles;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9saWIvQ29sdW1uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNvQiIsImZpbGUiOiIuLi9zcmMvbGliL0NvbHVtbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGcmFnbWVudCB9IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCBjbGFzc25hbWVzIGZyb20gJ2NsYXNzbmFtZXMnXG5cbmV4cG9ydCBjb25zdCBDb2x1bW4gPSAoeyBjaGlsZHJlbiwgY2xhc3NOYW1lLCBndXR0ZXJVbml0LCBzdGFjaywgc3BsaXQsIHNpemUsIGZsZXgsIGFsaWduIH0pID0+IHtcbiAgLy8gV2hlbiBzdGFjayBpcyBlbmFibGVkLCB3ZSBkb24ndCByZXR1cm4gdHJhY2VzIG9mIHRoZSBjb2x1bW5zIGRpdiB0YWdzXG4gIGlmIChzdGFjaykgcmV0dXJuIDxGcmFnbWVudD57Y2hpbGRyZW59PC9GcmFnbWVudD5cblxuICBjb25zdCBzdHlsZXMgPSBjc3NgXG4gICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICBtaW4td2lkdGg6IDA7XG4gICAgJHtndXR0ZXJVbml0ICYmICdtYXJnaW4tbGVmdDogJyArIGd1dHRlclVuaXQgKiAwLjUgKyAnZW07J31cbiAgICAke2d1dHRlclVuaXQgJiYgJ21hcmdpbi1yaWdodDogJyArIGd1dHRlclVuaXQgKiAwLjUgKyAnZW07J31cbiAgICAke3NpemUgJiYgIXNwbGl0ICYmICd3aWR0aDogJyArIHNpemUgKyAnZW07J31cbiAgICAke2ZsZXggJiYgIXNwbGl0ICYmICdmbGV4OiAxOyd9XG4gICAgJHthbGlnbiAmJiAndGV4dC1hbGlnbjogJyArIGFsaWduLnRvTG93ZXJDYXNlKCkgKyAnOyd9XG4gIGBcblxuICByZXR1cm4gKFxuICAgIDxkaXYgY3NzPXtzdHlsZXN9IGNsYXNzTmFtZT17Y2xhc3NuYW1lcygncmVhY3QtZmxleC1jb2x1bW4nLCBjbGFzc05hbWUsIHtcbiAgICAgIFtgcmVhY3QtZmxleC1jb2x1bW5zLWFsaWduLSR7YWxpZ259YF06ICEhYWxpZ24sXG4gICAgICAncmVhY3QtZmxleC1jb2x1bW5zLWZsZXgnOiAhIWZsZXhcbiAgICB9KX0+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9kaXY+XG4gIClcbn1cblxuQ29sdW1uLmRlZmF1bHRQcm9wcyA9IHtcbiAgc3BsaXQ6IGZhbHNlLFxuICBzdGFjazogZmFsc2UsXG4gIGRpc3BsYXk6IHRydWUsXG59XG5cbkNvbHVtbi5wcm9wVHlwZXMgPSB7XG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMubm9kZSxcbiAgY2xhc3NOYW1lOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBndXR0ZXJVbml0OiBQcm9wVHlwZXMubnVtYmVyLFxuICBzdGFjazogUHJvcFR5cGVzLmJvb2wsXG4gIHNwbGl0OiBQcm9wVHlwZXMuYm9vbCxcbiAgc2l6ZTogUHJvcFR5cGVzLm51bWJlcixcbiAgZmxleDogUHJvcFR5cGVzLmJvb2wsXG4gIGFsaWduOiBQcm9wVHlwZXMub25lT2YoWydsZWZ0JywgJ3JpZ2h0JywgJ2NlbnRlciddKVxufVxuXG5leHBvcnQgZGVmYXVsdCBDb2x1bW5cbiJdfQ== */"));
  return (0, _core.jsx)("div", {
    css: styles,
    className: (0, _classnames2.default)('react-flex-column', className, (_classnames = {}, _defineProperty(_classnames, "react-flex-columns-align-".concat(align), !!align), _defineProperty(_classnames, 'react-flex-columns-flex', !!flex), _classnames))
  }, children);
};

exports.Column = Column;
Column.defaultProps = {
  split: false,
  stack: false,
  display: true
};
Column.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  gutterUnit: _propTypes.default.number,
  stack: _propTypes.default.bool,
  split: _propTypes.default.bool,
  size: _propTypes.default.number,
  flex: _propTypes.default.bool,
  align: _propTypes.default.oneOf(['left', 'right', 'center'])
};
var _default = Column;
exports.default = _default;